import React, { useCallback, useEffect, useState } from 'react'
import { SwiperSlide } from 'swiper/react'
import Package from '../Package'
import Carousel from '../../../../Carousel'
import useDetectDevice from '../../../../../hooks/useDetectDevice'

function isElementFullyVisible(el) {
  const rect = el.getBoundingClientRect()
  const windowHeight = window.innerHeight || document.documentElement.clientHeight
  const windowWidth = window.innerWidth || document.documentElement.clientWidth

  return rect.top >= 0 && rect.left >= 0 && rect.bottom <= windowHeight && rect.right <= windowWidth
}

function MobilePackages({ packages, onPackageClicked, isActive, minimal }) {
  const [carousel, setCarousel] = useState()

  const { isMobile, isMobileLandscape } = useDetectDevice()

  const recalculateWidth = useCallback(() => {
    setTimeout(() => {
      document.getElementById('mobile-packages').style.opacity = 0
      const pills = document.querySelectorAll('.mobile-pill')
      Array.from(pills).forEach((p) => {
        p.style.width = `auto`
      })
      const largetPillWidth = Math.max(
        ...Array.from(pills).map((p) => {
          return p.getBoundingClientRect().width
        }),
      )
      Array.from(pills).forEach((p) => {
        p.style.width = `${largetPillWidth}px`
      })
      document.getElementById('mobile-packages').style.opacity = 1
    }, 10)
  }, [])

  useEffect(() => {
    recalculateWidth()
  }, [packages, recalculateWidth])

  useEffect(() => {
    recalculateWidth()
  }, [isMobile, isMobileLandscape, recalculateWidth])

  return (
    <Carousel
      spaceBetween={20}
      slidesPerView="auto"
      loop={false}
      onSwiper={setCarousel}
      centeredSlides={false}
      slidesOffsetAfter={20}
      slidesOffsetBefore={24}
      observer={true} // Watch for changes in the slides
      observeParents={true} // Watch for changes in the parent container
      id="mobile-packages"
      slides={packages.map((pack, index) => (
        <SwiperSlide style={{ width: 'max-content' }} key={pack.id}>
          <Package
            minimal={minimal}
            onClick={() => {
              if (
                !isElementFullyVisible(document.getElementById(`package-${packages.length - 1}`)) ||
                !isElementFullyVisible(document.getElementById(`package-0`))
              ) {
                carousel.slideTo(index)
              }
              onPackageClicked(pack)
            }}
            key={index}
            pack={pack}
            isActive={isActive(pack)}
            className="rounded-[6px] mobile-pill"
            id={`package-${index}`}
          />
        </SwiperSlide>
      ))}
    />
  )
}

export default MobilePackages
